"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPersonalShoppingAdviceMail = exports.postVoucher = exports.deleteVoucher = exports.postSwitchFictiveWebshop = exports.postCheckStockReservation = exports.postSavePoint = exports.getBasketBasic = exports.getBasket = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const createUrl_1 = require("../../utils/createUrl");
const basketEndpoints = {
    getBasket: { client: 'api/basket/token' },
    getBasketBasic: { client: 'api/basket/basic' },
    postSavePoint: { client: 'api/basket/savepoint' },
    postCheckStockReservation: { client: 'api/basket/stock/reserve' },
    postSwitchFictiveWebshop: { client: 'api/basket/fictive/switch' },
    voucher: { client: 'api/basket/voucher' },
    sendPersonalShoppingAdviceMail: { client: 'api/personalshoppingadvice/sendmail' },
};
const getBasket = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.getBasketBasic, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        signal,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getBasket = getBasket;
const getBasketBasic = (_c, _d) => tslib_1.__awaiter(void 0, [_c, _d], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { signal }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.getBasketBasic, isServer);
    const axiosConfig = {
        method: 'GET',
        url,
        params: defaultRequestParams,
        withCredentials: true,
        signal,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.getBasketBasic = getBasketBasic;
const postSavePoint = (_e) => tslib_1.__awaiter(void 0, [_e], void 0, function* ({ servicesEndpoint, isServer }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.postSavePoint, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSavePoint = postSavePoint;
const postCheckStockReservation = (_f) => tslib_1.__awaiter(void 0, [_f], void 0, function* ({ servicesEndpoint, isServer }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.postCheckStockReservation, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postCheckStockReservation = postCheckStockReservation;
const postSwitchFictiveWebshop = (_g) => tslib_1.__awaiter(void 0, [_g], void 0, function* ({ servicesEndpoint, isServer }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.postSwitchFictiveWebshop, isServer);
    const axiosConfig = {
        method: 'POST',
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postSwitchFictiveWebshop = postSwitchFictiveWebshop;
const deleteVoucher = (_h, code_1) => tslib_1.__awaiter(void 0, [_h, code_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, code) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.voucher, isServer);
    const axiosConfig = {
        method: 'DELETE',
        params: Object.assign(Object.assign({}, defaultRequestParams), { voucher: code }),
        url,
        withCredentials: true,
    };
    return axios_1.default.request(axiosConfig);
});
exports.deleteVoucher = deleteVoucher;
const postVoucher = (_j, _k) => tslib_1.__awaiter(void 0, [_j, _k], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, { code, webcode }) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.voucher, isServer);
    const axiosConfig = {
        method: 'POST',
        params: Object.assign(Object.assign(Object.assign({}, defaultRequestParams), { voucher: code }), (webcode && { controlCode: webcode })),
        url,
        withCredentials: true,
    };
    const result = yield axios_1.default.request(axiosConfig);
    return result.data;
});
exports.postVoucher = postVoucher;
const sendPersonalShoppingAdviceMail = (_l, email_1) => tslib_1.__awaiter(void 0, [_l, email_1], void 0, function* ({ servicesEndpoint, isServer, defaultRequestParams }, email) {
    const url = (0, createUrl_1.createUrl)(servicesEndpoint, basketEndpoints.sendPersonalShoppingAdviceMail, isServer);
    const axiosConfig = {
        method: 'POST',
        params: Object.assign(Object.assign({}, defaultRequestParams), { email }),
        url,
        withCredentials: true,
    };
    return axios_1.default.request(axiosConfig);
});
exports.sendPersonalShoppingAdviceMail = sendPersonalShoppingAdviceMail;
//# sourceMappingURL=basket.api.js.map